import { ApplicationState } from 'application/redux';
import { executeCommand } from 'core/utils/deviceUtils';
import { connect } from 'react-redux';
import ChannelComponent from './channels-component';
import {
  cancelCommand,
  fetch,
  fetchChannelScan as startScan,
  toggleAccordion
} from './redux/actions';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  hhid: ownProps.hhid,
  id: ownProps.id,
  results: state.devices.detail.channels,
  t: state.i18n.t,
  general: state.devices.detail.general,
  offset: state.application.offset,
});

export default connect(mapStateToProps, { startScan, fetch, toggleAccordion, cancelCommand, executeCommand })(
  ChannelComponent
);
